<template>
  <td v-if="Array.isArray(field.filterable)">
    <multiselect
      v-model="inputSelect"
      :options="field.filterable"
      track-by="value"
      label="text"
      :disabled="isLoading"
      :show-labels="false"
      :searchable="true"
      @input="select"
      openDirection="below"
      :maxHeight="150"
    >
      <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
    </multiselect>
  </td>
  <td v-else-if="field.filterable === 'date'">
    <date-picker mode='range' v-model='range' is-range>
      <template v-slot="{ inputValue, inputEvents }">
        <div class="flex justify-center items-center text-container">
          <b-form-input
            v-if="inputValue.start == inputValue.end"
            id="date" size="lg"
            readonly="readonly"
            :value="inputValue.start"
            :disabled="isLoading"
            v-on="inputEvents.start"
            class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
            @input="filter(inputValue.start)"
          />
          <b-form-input v-else
                        id="date" size="lg"
                        readonly="readonly"
                        :value="inputValue.start +' - ' + inputValue.end"
                        v-on="inputEvents.start"
                        class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                        @input="filter(inputValue.start +' - ' + inputValue.end)"
          />
          <button
            v-if="range && range.start != null"
            class="clearBtn"
            @click="range = null; $emit('onFilter', null);">
            <i :class="$getConst.icons.close"></i>
          </button>
          <!--<b-form-group label="to">-->
          <!--<b-form-input-->
          <!--label="to"-->
          <!--:value="inputValue.end"-->
          <!--v-on="inputEvents.end"-->
          <!--class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"-->
          <!--/>-->
          <!--</b-form-group>-->
        </div>
      </template>
    </date-picker>
  </td>
  <td v-else-if="field.filterable">
    <b-form-input
      size="sm"
      :disabled="isLoading"
      v-model="input"></b-form-input>
  </td>
  <td v-else></td>
</template>

<script>
  import {DatePicker} from 'v-calendar'
  import {debounce} from "lodash";

  export default {
    name: "TableFilterColumn",
    components: {
      DatePicker
    },
    props: {
      field: null,
      filters: null,
      isLoading: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        date:null,
        input: null,
        inputSelect: null,
        filterData: null,
        range: {
          start: null,
          end: null,
        },
      }
    },
    created() {
      for (let item in this.filters) {
        if (item === this.field.key) {
          this.filterData = this.filters[item];
          this.input = this.filters[item];
          break;
        }
      }
      if (Array.isArray(this.field.filterable) && this.field.filterable[0].value !== null) {
        this.field.filterable.unshift({value: null, text: ''})
      }
      this.debounceInput = debounce(this.filter, 500);
    },
    methods: {
      filter(date) {
        if(date){
          this.range = null;
          this.$emit('onFilter', null);
        }else{
          this.$emit('onFilter', this.input);
        }

      },
      select(value) {
        if (value && value.value === null) {
          value = null
        }
        this.$emit('onFilter', value)
      }
    },
    watch: {
      input() {
        if (this.input !== this.filterData) {
          this.debounceInput();
        }
      },
      range: {
        handler: function () {
          if(this.range) {
            let start = "" + this.range.start.getFullYear() + ((this.range.start.getMonth() + 1) > 9 ? '' : '0') + (this.range.start.getMonth() + 1) + (this.range.start.getDate() > 9 ? '' : '0') + this.range.start.getDate();
            let end = "" + this.range.end.getFullYear() + ((this.range.end.getMonth() + 1) > 9 ? '' : '0') + (this.range.end.getMonth() + 1) + (this.range.end.getDate() > 9 ? '' : '0') + (this.range.end.getDate());
            this.input = ['[' + start, end + ']'];
          }
        }
      }
    }
  }
</script>

<style scoped>
  .form-control:disabled, .form-control[readonly] {
    background-color: rgba(0, 0, 0, 0.03);
  }
  .text-container {
    display: inline-block;
    position: relative;
    overflow: hidden;
  }
  .clearBtn {
    position: absolute;
    top: 20%;
    right: 2%;
    background-color: transparent;
    transition: right 0.2s;
    border: 0px !important;
  }
</style>
